import { FishbrainLayers } from '../types/types';

export enum Domain {
  RUTILUS,
  TILES,
}

export interface Source {
  name: string;
  minzoom: number;
  maxzoom: number;
  tilesDomain: Domain;
  tilesPath: string;
  premiumOnly: boolean;
  type: 'vector' | 'raster';
}

export const SOURCE: FishbrainLayers<Source> = {
  catchPositions: {
    name: 'catch_position_source',
    minzoom: 0, // default Mapbox value
    maxzoom: 22, // default Mapbox value
    tilesDomain: Domain.RUTILUS,
    tilesPath: '/v2/tiles/catches/{z}/{x}/{y}.pbf',
    premiumOnly: true,
    type: 'vector',
  },
  fishingWaters: {
    name: 'fishing_waters_source',
    minzoom: 4,
    maxzoom: 8,
    tilesDomain: Domain.TILES,
    tilesPath: '/fishing_waters/{z}/{x}/{y}.pbf',
    premiumOnly: false,
    type: 'vector',
  },
  pointsOfInterest: {
    name: 'points_of_interest_source',
    minzoom: 4,
    maxzoom: 8,
    tilesDomain: Domain.TILES,
    tilesPath: '/points_of_interest/{z}/{x}/{y}.pbf',
    premiumOnly: false,
    type: 'vector',
  },
  artificialReefs: {
    name: 'artificial_reefs_source',
    minzoom: 4,
    maxzoom: 8,
    tilesDomain: Domain.TILES,
    tilesPath: '/artificial_reefs/{z}/{x}/{y}.pbf',
    premiumOnly: true,
    type: 'vector',
  },
  spotPrediction: {
    name: 'spot_prediction_source',
    minzoom: 8,
    maxzoom: 11,
    tilesDomain: Domain.TILES,
    tilesPath: '/spot_prediction_v3/{z}/{x}/{y}.png',
    premiumOnly: true,
    type: 'raster',
  },
  waypoints: {
    name: 'waypoints_source',
    minzoom: 8,
    maxzoom: 21,
    tilesDomain: Domain.RUTILUS,
    tilesPath: '/tiles/waypoints/{z}/{x}/{y}.pbf',
    premiumOnly: true,
    type: 'vector',
  },
};
